<template>
    <div>
      <div class="loader" v-if="this.isLoading"></div>   
      <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
      <div class="main-wrapper" :class="{'blur-content': this.isLoading}">
  
          <!--begin::navbar-->
          <navbar-component></navbar-component>
          <!--end::navbar-->
  
        <div class="page-wrapper">
  
          <!--begin::content-->
          <div class="page-content">
            <div class="row">
              <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
                <div class="card">
                  <div class="card-header">
                    <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                    &nbsp;&nbsp;&nbsp;
                    <h6 class="card-title mb-0 float-start" style="padding-left:25px">{{ $t("rate_detail_txt") }}</h6>
                    <button
                      class="btn btn-light float-end"
                      type="button"
                      data-bs-toggle="collapse" 
                      data-bs-target="#collapseExample" 
                      aria-expanded="false" 
                      aria-controls="collapseExample"
                    >
                      <i class="link-icon" data-feather="info"></i>
                      Audit Info
                    </button>
  
                    <div class="row mb-3 collapse" id="collapseExample" style="padding-left:20px">
                      <div class="col-lg-3">
                        <label class="tx-11 fw-bolder mb-0 ">Created By:</label>
                        <p class="text-muted">{{this.forms.addwho}}</p>
                      </div>
  
                      <div class="col-lg-3">
                        <label class="tx-11 fw-bolder mb-0">Created At:</label>
                        <p class="text-muted">{{this.forms.adddate}}</p>
                      </div>
  
                      <div class="col-lg-3">
                        <label class="tx-11 fw-bolder mb-0">Updated By:</label>
                        <p class="text-muted">{{this.forms.editwho}}</p>
                      </div>
  
                      <div class="col-lg-3">
                        <label class="tx-11 fw-bolder mb-0">Updated At:</label>
                        <p class="text-muted">{{this.forms.editdate}}</p>
                      </div>
  
                      
                      
                    </div>
  
                  </div>
  
                  <div class="card-body">
  
                    <div class="row mb-3 container-fluid">
                        <div class="col-md-3">
                            <label class="form-label">{{$t('idRateHeader')}}</label>
                            <input  type="text" class="form-control" id="idRateHeader" :placeholder="$t('idRateHeader')" v-model="forms.idRateHeader" disabled />
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">{{
                              $t('organizationId')
                            }}</label>
                            <input type="text" class="form-control" id="organizationId" :placeholder="$t('organizationId')" v-model="forms.organizationId" disabled />
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">{{
                              $t('customerSAPCode')
                            }}</label>
                            <input type="text" class="form-control" id="customerSAPCode" :placeholder="$t('customerSAPCode')" v-model="forms.customerSAPCode" disabled />
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">{{$t('tarifMasterId')}}</label>
                            <input  type="text" class="form-control" id="tarifMasterId" :placeholder="$t('tarifMasterId')" v-model="forms.tarifMasterId" disabled />
                        </div>
                    </div>
          
                    <div class="row mb-3 container-fluid">
                        <div class="col-md-3">
                            <label class="form-label">{{$t('customerId')}}</label>
                            <input  type="text" class="form-control" id="customerId" :placeholder="$t('customerId')" v-model="forms.customerId" disabled />
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">{{
                              $t('warehouseId_txt')
                            }}</label>
                            <input type="text" class="form-control" id="warehouseId" :placeholder="$t('warehouseId_txt')" v-model="forms.warehouseId" disabled />
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">{{
                              $t('opportunity_id')
                            }}</label>
                            <input type="text" class="form-control" id="opportunity_id" :placeholder="$t('opportunity_id')" v-model="forms.opportunity_id" disabled />
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">{{$t('contract_no')}}</label>
                            <input  type="text" class="form-control" id="rateName" :placeholder="$t('contract_no')" v-model="forms.rateName" disabled />
                        </div>
                        
                    </div>

                    <div class="row mb-3 container-fluid">
                        <div class="col-md-3">
                            <label class="form-label">{{$t('statusTxt')}}</label>
                            <input  type="text" class="form-control" id="status" :placeholder="$t('statusTxt')" v-model="forms.status" disabled />
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">{{
                              $t('firstBilingDate')
                            }}</label>
                            <input type="text" class="form-control" id="firstBilingDate" :placeholder="$t('firstBilingDate')" v-model="forms.firstBilingDate" disabled />
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">{{
                              $t('effectiveFromDate')
                            }}</label>
                            <input type="text" class="form-control" id="effectiveFromDate" :placeholder="$t('effectiveFromDate')" v-model="forms.effectiveFromDate" disabled />
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">{{
                              $t('effectiveToDate')
                            }}</label>
                            <input type="text" class="form-control" id="effectiveToDate" :placeholder="$t('effectiveToDate')" v-model="forms.effectiveToDate" disabled />
                        </div>
                        
                        
                    </div>
  
                    <div class="row mb-3 container-fluid">
                        <div class="col-md-4">
                            <label class="form-label">{{
                              $t('rateDesc')
                            }}</label>
                            <input type="text" class="form-control" id="rateDesc" :placeholder="$t('rateDesc')" v-model="forms.rateDesc" disabled />
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">{{$t('billingPeriode')}}</label>
                            <input  type="text" class="form-control" id="billingPeriode" :placeholder="$t('billingPeriode')" v-model="forms.billingPeriode" disabled />
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">{{
                              $t('additionalDataWMSFlag')
                            }}</label>
                            <input type="text" class="form-control" id="additionalDataWMSFlag" :placeholder="$t('additionalDataWMSFlag')" v-model="forms.additionalDataWMSFlag" disabled />
                        </div>
                        <div class="col-md-2">
                            <label class="form-label">{{
                              $t('sapDataFlag')
                            }}</label>
                            <input type="text" class="form-control" id="sapDataFlag" :placeholder="$t('sapDataFlag')" v-model="forms.sapDataFlag" disabled />
                        </div>
                    </div>
  
                    <div class="card-footer">
                        <button
                          class="
                            btn btn-warning
                            text-black
                            fw-bolder
                            btn-icon-text
                          "
                          @click="backForm"
                          type="button"
                        >
                          <i class="link-icon mdi mdi-arrow-left"></i>
                          {{ $t("backMess") }}
                        </button>
                        &nbsp;&nbsp;
                        <button
                          class="
                            btn btn-primary
                            text-black
                            fw-bolder
                            btn-icon-text
                          "
                          @click="downloadData()"
                          type="button"
                        >
                          <i class="link-icon mdi mdi-download"></i>
                          {{ $t("downloadData") }}
                        </button>
                        &nbsp;&nbsp;
                        <button
                              class="
                                btn btn-info
                                text-black
                                fw-bolder
                                btn-icon-text
                              "
                              @click="open_bm_tarif_master_header()"
                              type="button"
                            >
                            <i class="link-icon mdi mdi-eye"></i>
                              {{ $t("tarifMasterId") }}
                          </button>
                        &nbsp;&nbsp;
                        <button v-if="permision_role.method_create"
                          class="
                            btn btn-success
                            text-black
                            fw-bolder
                            btn-icon-text
                          "
                          @click="detailHandling()"
                          type="button"
                        >
                          <i class="link-icon mdi mdi-eye"></i>
                          {{ $t("detailHandling") }}
                        </button>
                        &nbsp;&nbsp;
                        <button v-if="permision_role.method_create"
                          class="
                            btn btn-info
                            text-black
                            fw-bolder
                            btn-icon-text
                          "
                          @click="detailStorage()"
                          type="button"
                        >
                          <i class="link-icon mdi mdi-eye"></i>
                          {{ $t("detailStorage") }}
                        </button>
                         
                        &nbsp;&nbsp;
                        <button v-if="permision_role.method_update"
                          class="
                            btn btn-danger
                            text-black
                            fw-bolder
                            btn-icon-text
                          "
                          @click="editData()"
                          type="button"
                        >
                          <i class="link-icon mdi mdi-grease-pencil"></i>
                          {{ $t("editMess") }}
                        </button>
   
                     </div>
                      
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--end::content-->
  
  
        <!--begin::modal-->
          

        <modal name="bm_tarif_master_header" :draggable="false" :scrollable="true" :height="'auto'">
            <div class="modal fade show" tabindex="-1" style="display: block;margin-top: 2%;" aria-modal="true" role="dialog">
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
  
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">{{this.$t("tarifMasterId")}}</h5>
                    <button type="button" class="btn-close" aria-label="btn-close" @click.prevent="removeModals()"></button>
                  </div>
  
                  <div class="modal-body">
                      
        
                    <div class="mb-3">
                      <label for="idTarifMasterHeader" class="form-label">{{this.$t("idTarifMasterHeader")}}:</label>
                      <input type="text" class="form-control" id="idTarifMasterHeader" :placeholder="$t('idTarifMasterHeader')" v-model="formsTarifMasterHeader.idTarifMasterHeader" disabled/>
                    </div>
        
                    <div class="mb-3">
                      <label for="tarifMasterId" class="form-label">{{this.$t("tarifMasterId")}}:</label>
                      <input type="text" class="form-control" id="tarifMasterId" :placeholder="$t('tarifMasterId')" v-model="formsTarifMasterHeader.tarifMasterId" disabled/>
                    </div>
        
                    <div class="mb-3">
                      <label for="customerId" class="form-label">{{this.$t("customerId")}}:</label>
                      <input type="text" class="form-control" id="customerId" :placeholder="$t('customerId')" v-model="formsTarifMasterHeader.customerId" disabled/>
                    </div>
        
                    <div class="mb-3">
                      <label for="warehouseId" class="form-label">{{this.$t("warehouseId_txt")}}:</label>
                      <input type="text" class="form-control" id="warehouseId" :placeholder="$t('warehouseId_txt')" v-model="formsTarifMasterHeader.warehouseId" disabled/>
                    </div>
        
                    <div class="mb-3">
                      <label for="queryRateHeader" class="form-label">{{this.$t("query")}}:</label>
                      <textarea class="form-control" id="queryRateHeader" :placeholder="$t('query')" v-model="formsTarifMasterHeader.queryRateHeader" disabled></textarea>
                    </div>
        
                   
        
                    <div class="mb-3">
                      <label for="status" class="form-label">{{this.$t("statusTxt")}}:</label>
                      <input type="text" class="form-control" id="status" :placeholder="$t('statusTxt')" v-model="formsTarifMasterHeader.status" disabled/>
                    </div>
        
                    <div class="mb-3">
                      <label for="addwho" class="form-label">{{this.$t("addwho")}}:</label>
                      <input type="text" class="form-control" id="addwho" :placeholder="$t('addwho')" v-model="formsTarifMasterHeader.addwho" disabled/>
                    </div>
        
        
                    <div class="mb-3">
                      <label for="adddate" class="form-label">{{this.$t("adddate")}}:</label>
                      <input type="text" class="form-control" id="adddate" :placeholder="$t('adddate')" v-model="formsTarifMasterHeader.adddate" disabled/>
                    </div>
        
        
                    <div class="mb-3">
                      <label for="editwho" class="form-label">{{this.$t("editwho")}}:</label>
                      <input type="text" class="form-control" id="editwho" :placeholder="$t('editwho')" v-model="formsTarifMasterHeader.editwho" disabled/>
                    </div>
        
        
                    <div class="mb-3">
                      <label for="editdate" class="form-label">{{this.$t("editdate")}}:</label>
                      <input type="text" class="form-control" id="editdate" :placeholder="$t('editdate')" v-model="formsTarifMasterHeader.editdate" disabled/>
                    </div>
        
        
                    
        
        
        
                  </div>
  
                  <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">{{this.$t("close_txt")}}</button>
                  </div>
  
              </div>
            </div>
          </div>
        </modal>
          

        <!--end::modal-->
  
  
          <!--begin::footer-->
          <footer-component></footer-component>
          <!--end::footer-->
        </div>
      </div>
    </div>
</template>
  
  
  <script>
  import navbarComponent from "@/components/_partials/_navbar";
  import footerComponent from "@/components/_partials/_footer";
  
  export default {
    name: "CmlRateHeaderDetail",
    props: {},
    components: {
      "navbar-component": navbarComponent,
      "footer-component": footerComponent,
    },
    data() {
      return {
        fetchchargeCategory:[],
        fetchchargeType:[],
        fetchrateBase:[],
        chargeCategory:"",
        chargeType:"",
        rateBase:"",
        permision_role:[],
        isLoading: false,
        maxToasts: 100,
        position: "up right",
        closeBtn: true,
        errors: [],
        userData: "",
        companyCode: "",
        companyName:"",
        forms: { billingPeriode:"", opportunity_id:"", idRateHeader: "",  organizationId:"", tarifMasterId: "" , customerId:"", customerSAPCode:"", warehouseId:"",  rateName:"" , effectiveDate:"", rateDesc:"",  firstBilingDate:"", effectiveFromDate:"", effectiveToDate:"", status:"", addwho:"",  editwho:"", adddate:"",  editdate:""},
        formsTarifMasterHeader:{idTarifMasterHeader: "", tarifMasterId: "" , warehouseId:"", customerId:"", status:"", queryRateHeader:"", addwho:"", editwho:"",  adddate:"", editdate:""},
        bm_rate_detail_handling:[],
        bm_rate_subdetail_storagecharge:[],
      };
    },
    watch: {},
    methods: {
  
  
      editDataDetail(index,row) {
        this.rateDetail       = row;
        this.chargeCategory   = {chargeType:row.chargeCategory}
        this.chargeType       = {chargeType:row.chargeType}
        this.rateBase         = {categoryCode:row.chargeCategory,chargeType:row.chargeType,rateBase:row.rateBase,materialCode:row.SAPMaterialCode,query_data:row.query}
        this.$modal.show('editBillingCliRateDetail')
      },
  
      detailDataDetail(index,row) {
        this.rateDetail     = row;
        this.rateDetail.query_data      = row.query
        this.$modal.show('detailBillingCliRateDetail')
      },
  
      open_bm_tarif_master_header(){
        
        this.$modal.show('bm_tarif_master_header')
  
      },
      
      removeModals(){
        
        this.$modal.hide('bm_tarif_master_header')
  
      },
  
  
      cek_message(status, msg) {
        if (status == "200") {
          this.success(msg);
        }
      },
  
      editData() {
        var params = this.$route.params.id;
        window.location.href = "/billing-cml/rates/header/edit/" + params;
      },
  
      detailHandling() {
        var params = this.$route.params.id;
        window.location.href = "/billing-cml/rates/detail-handling/" + params;
      },
  
      detailStorage() {
        var params = this.$route.params.id;
        window.location.href = "/billing-cml/rates/detail-storage/" + params;
      },
  
  
      backForm() {
        window.location.href = "/billing-cml/rates/header";
      },
  
      loadData(id) {
        this.isLoading = true;
  
        const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/rate/header/detail/" + id;
        return this.$http.get(baseURI,{ timeout: 30000 }).then((response) => {
         this.isLoading = false;
          this.forms                    = response.data.datas;
          this.formsTarifMasterHeader   = response.data.datas.bm_tarif_master_header;
          this.forms.effectiveDate      = response.data.datas.effectiveFromDate+"~"+response.data.datas.effectiveToDate
          this.bm_rate_detail_handling  = response.data.datas.bm_rate_detail_handling;
          this.bm_rate_detail_storage   = response.data.datas.bm_rate_detail_storage;
        }).catch(error => {
            this.isLoading = false;
            
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }

  
          });
      },
  
      logout(){

          const baseURI = this.$settings.endPoint + "user/logout";
          this.$http.get(baseURI, { timeout: 60000 }).then((response) => {
              
          console.log(response);

          });

          this.$logoutUser();
          window.location.href = '/';
      },

      fetchIt() {
        const userDatas     = this.$getUserInfo();
        this.detailUser     = userDatas.sub;
        // this.permision_role = userDatas.sub.permision_role;
        let rolePermision = [];
        userDatas.sub.permision_role.forEach(function(permision){
          if(permision.permission.controller == 'RateHeaderCmlController'){
  
            rolePermision = permision;
            // console.log(permision);
          }
        });
  
        if(!rolePermision.method_read){
          this.$router.push("/authorized-error");
        }
        this.permision_role = rolePermision;
  
      },
   
  
      fade(sType) {
        this.isLoading = sType;
      },
  
      loading() {
        this.fade(true);
        setTimeout(() => {
          this.fade(false);
        }, 1000); // hide the message after 3 seconds
      },
  
      resultError(data) {
        var count = Object.keys(data).length;
        for (var x = 0; x < count; x++) {
          var nameOb = Object.keys(data)[x];
          var objectData = data[nameOb];
          for (var y = 0; y < objectData.length; y++) {
            this.error(objectData[y]);
          }
        }
      },
  
      success(kata) {
        const Toast = this.$swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          },
          // onShown: function() {
          //     console.log('asdasdasd');
          //     //window.location.href = '/';
          // }
        });
  
        Toast.fire({
          icon: "success",
          title: kata,
        });
      },
  
      error(kata) {
        const Toast = this.$swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          },
        });
        Toast.fire({
          icon: "error",
          title: kata,
        });
      },


      downloadData() {
            this.cek_message(this.$route.query.status, this.$route.query.msg);
            var params = this.$onBehind(this.$route.params.id);
            const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/rate/header/detail/"+params[0]+"?download=download";
            var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
            var file_name = "download_" + CurrentDate + ".xlsx";
    
            
            return this.$http
            .get(
                baseURI,
                {
                responseType: "blob",
                }
            )
            .then((response) => {
            
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement("a");
    
                fileLink.href = fileURL;
                fileLink.setAttribute("download", file_name);
                document.body.appendChild(fileLink);
                fileLink.click();
                this.fade(false);
            });
        },

    },
    events: {},
    created: function () {},
    mounted() {
      this.cek_message(this.$route.query.status, this.$route.query.msg);
      var params = this.$onBehind(this.$route.params.id);
      this.loadData(params[0]);
      this.fetchIt();
    },
  };
  </script>
  <style scoped>
  
  </style>